/**
 * 站点三段条(生成 → 预览调整 → 上线,1010 流程改造;原五步条「选模板 → 资料采集 → 内容编辑 → 域名绑定 → 发布」)的**当前段派生**。
 *
 * ★ 零新状态(与 `@/shared/ui/StepIndicator` 的纪律一致):当前段只从站点已有的字段读出来,不另存一个 `step` 让两处漂。
 *   - 还没有草稿、也没发布过预览 → ①生成;
 *   - 有草稿或有预览版本、但还没正式上线 → ②预览调整;
 *   - 正式上线过(`launched`,老后端没这键时按 `status != draft`)→ ③上线。
 * ★ 上线态压过草稿态:上线过的站不会因为 `hasDraft=false` 退回生成段。
 * ★ 一键生成会把预览发布到免费子域名(站点仍算草稿态),所以「有版本号」不等于「上线了」—— 上线只看 `launched` / `status`。
 */
import type { SiteCard } from "../api/types";

export const STEPS = ["生成", "预览调整", "上线"] as const;

/** 派生只需要这几个字段;SiteCard 与 SiteDetail 都带齐,列表页 / 详情页都能喂。 */
export type StepSite = Pick<SiteCard, "hasDraft" | "status" | "currentVersionNo"> &
  Partial<Pick<SiteCard, "launched" | "collectProgress" | "primaryDomain">>;

/** 正式上线过没有:api 给了 `launched` 就用它,没给退到 `status != draft`(老站点:发布过即上线)。 */
export function isLaunched(site: Pick<StepSite, "status" | "launched">): boolean {
  if (typeof site.launched === "boolean") return site.launched;
  return site.status !== "draft";
}

/** 当前第几段,1-based(1..3)。 */
export function stepOf(site: StepSite): number {
  if (isLaunched(site)) return 3;
  if (site.hasDraft || site.currentVersionNo != null) return 2;
  return 1;
}

/** 三段各自的页面(站点级路由)。 */
export const STEP_PATHS = ["generate", "preview", "launch"] as const;
export type StepPath = (typeof STEP_PATHS)[number];

/** 「继续」该去哪一段:按当前段派生。 */
export function stepPath(site: StepSite): StepPath {
  return STEP_PATHS[stepOf(site) - 1];
}

export function sitePath(id: string, page: string): string {
  return `/ai-website/sites/${encodeURIComponent(id)}/${page}`;
}
